import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ScheduledReportsAPI from '../../api/scheduledReports';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getScheduledReports(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }) {
    commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isFetching: true });
    try {
      const response = await ScheduledReportsAPI.get();
      commit(types.SET_SCHEDULED_REPORTS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isFetching: false });
    }
  },

  create: async function create({ commit }, payload) {
    commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isCreating: true });
    try {
      const response = await ScheduledReportsAPI.create(payload);
      commit(types.ADD_SCHEDULED_REPORT, response.data.payload);
      return response.data.payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isCreating: false });
    }
  },

  update: async function update({ commit }, { id, ...payload }) {
    commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isUpdating: true });
    try {
      const response = await ScheduledReportsAPI.update(id, payload);
      commit(types.EDIT_SCHEDULED_REPORT, response.data.payload);
      return response.data.payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteReport({ commit }, id) {
    commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledReportsAPI.delete(id);
      commit(types.DELETE_SCHEDULED_REPORT, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_SCHEDULED_REPORTS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_SCHEDULED_REPORTS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SCHEDULED_REPORTS]: MutationHelpers.set,
  [types.ADD_SCHEDULED_REPORT]: MutationHelpers.create,
  [types.EDIT_SCHEDULED_REPORT]: MutationHelpers.update,
  [types.DELETE_SCHEDULED_REPORT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
